import userRoles from 'app/userRoles';
import React from 'react';

const CodesConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    'ROLE_SUPER_ADMIN',
    'FRANCHISEE_CODES_LIST',
  ],
  routes: [
    {
      path: '/my-codes',
      exact: true,
      component: React.lazy(() => import('.'))
    }
  ]
};

export { CodesConfig };
